import React from 'react';
import { authConfig } from '../config';
import { auth0Strategy } from './auth0';
import { cognitoStrategy } from './cognito';

const authStrategy = {
  AuthProvider: ({ children }) => {
    return <>{children}</>;
  },
  LoginComponent: () => <></>,
  LogoutComponent: () => <></>,
  getAccessToken: async () => null,
  withAccessToken: ({ children }) => {
    return <>{children}</>;
  },
  getCurrentUserId: async () => null,
  hasActiveSession: async () => false,
  allowEditName: true,
  allowEditPhone: true,
  allowEditEmail: true,
  allowEditBirthday: true,
  allowEditAddress: true,
  allowChangePassword: true,
  allowMFA: true,
  allowCreateUser: true,
  allowDeleteUser: true,
  profileExplanation: null,
  showInitialPassword: true,
  editUserLoginText: 'Editing this information will affect user log in.',
};

let authStrategyToUse = {};

switch (authConfig.provider) {
  case 'auth0':
    authStrategyToUse = auth0Strategy;
    break;
  case 'cognito':
  default:
    authStrategyToUse = cognitoStrategy;
    break;
}

Object.keys(authStrategyToUse).forEach((key) => {
  authStrategy[key] = authStrategyToUse[key];
});

export { authStrategy as AuthStrategy };
